export default "dist/images/components-design-separator-control-straight-1.fba0f99.png";